import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=55bb1dc7&scoped=true"
import script from "./edit.vue?vue&type=script&lang=ts"
export * from "./edit.vue?vue&type=script&lang=ts"
import style0 from "../book/book.style.scss?vue&type=style&index=0&id=55bb1dc7&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bb1dc7",
  null
  
)

export default component.exports